import { FaSearch } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import "../commonStyle.css";
import {
  CAvatar,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UPDATE_REPORTS_POST_LIST } from "../../store/actionTypes";
import { debounce } from "lodash";
import CustomPagination from "../customPagination";
import { BsSortAlphaDown, BsSortAlphaDownAlt } from "react-icons/bs";
import { BsSortNumericDownAlt, BsSortNumericDown } from "react-icons/bs";
import CIcon from "@coreui/icons-react";
import { cilCamera } from "@coreui/icons";
import DefaultPost from "../../assets/images/DefaultPostthumbnail.svg";
import ProperSpinner from "../spinner/ProperSpinner";
import {
  dateFormatter,
  getDateAndTimeFormatted,
  isVideo,
} from "../../utils/commonFunctions";

/**
 * @function ReportedPostTable
 * @description for ReportedPostTable
 * @returns JSX for ReportedPostTable
 */

const ReportedPostTable = ({ selectedIdHandler }) => {
  const {
    dataList: postsList,
    pageNo,
    totalPage,
    limit,
    searchKey,
    isLoading,
    sortOrder,
    sortBy,
  } = useSelector((state) => state.ReportReducer.post.reportedPost);

  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState(searchKey);

  const handlerSort = (sortBy) => {
    dispatch({
      type: UPDATE_REPORTS_POST_LIST,
      payload: { sortBy: sortBy, sortOrder: sortOrder === 1 ? -1 : 1 },
    });
  };

  const updatePage = (page) => {
    dispatch({
      type: UPDATE_REPORTS_POST_LIST,
      payload: { pageNo: page },
    });
  };

  const pageLimitHandler = (e) => {
    const currLimit = e?.target?.value;
    dispatch({
      type: UPDATE_REPORTS_POST_LIST,
      payload: { limit: currLimit, pageNo: 1 },
    });
  };

  const handleDebounceFn = (input) => {
    dispatch({
      type: UPDATE_REPORTS_POST_LIST,
      payload: { searchKey: input, pageNo: 1 },
    });
  };
  const deBounceFn = useMemo(() => debounce(handleDebounceFn, 500), []);

  const handleChange = (e) => {
    const text = e.target.value.replace(/[^a-zA-Z\s]/g, "").trimStart();
    setInputValue(text);
    if (text.length == 0 || text.length > 2) {
      deBounceFn(text);
    }
  };

  const handleClearInputField = () => {
    setInputValue("");
    deBounceFn("");
  };

  const renderTableBody = () => {
    return (
      <CTableBody>
        {postsList?.length > 0 &&
          postsList?.map((post, i) => {
            const mediaUrl = post?.mediaUrl?.url
              ? post.mediaUrl?.url
              : post?.mediaUrl;
            return (
              <CTableRow key={i} className="table-data-text">
                <CTableDataCell className="table-heading-10-cell ">
                  {mediaUrl && isVideo(mediaUrl) ? (
                    <video className="video-avatar">
                      <source src={mediaUrl} />
                    </video>
                  ) : (
                    <CAvatar
                      size="sm"
                      src={mediaUrl ? mediaUrl : DefaultPost}
                      style={{ objectFit: "cover" }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = DefaultPost;
                      }}
                    />
                  )}
                </CTableDataCell>
                <CTableDataCell
                  onClick={() => selectedIdHandler(post?._id)}
                  className="name-link table-heading-30-cell"
                >
                  {post?.title.length > 25
                    ? post.title.substr(0, 25) + "..."
                    : post.title || "N/A"}
                </CTableDataCell>
                <CTableDataCell className="table-heading-20-cell">
                  {post?.reportCount || "N/A"}
                </CTableDataCell>
                <CTableDataCell className="table-heading-20-cell">
                  {getDateAndTimeFormatted(post?.createdAt)}
                </CTableDataCell>
                <CTableDataCell className="table-heading-20-cell">
                  {getDateAndTimeFormatted(post?.reportedAt)}
                </CTableDataCell>
              </CTableRow>
            );
          })}
      </CTableBody>
    );
  };

  const renderPagination = () => {
    return (
      <CustomPagination
        limit={limit}
        limitHanlder={pageLimitHandler}
        pageNo={pageNo}
        pageChangeHanlder={updatePage}
        totalPage={totalPage}
      />
    );
  };

  const renderNoDataFound = () => {
    // if (!isLoading && !searchKey.length)
    if (isLoading) {
      return (
        <div className="ndf-container">
          <h3 className="ndf-heading">
            <span>{" Fetching posts "}</span> {"..."}
          </h3>
        </div>
      );
    }
    return (
      <div className="ndf-container">
        <h3 className="ndf-heading">
          {"No"}
          <span>{" posts "}</span> {"available !!!"}
        </h3>
      </div>
    );
  };

  const renderView = () => {
    return (
      <div>
        <div className="table-header-container">
          <h3 className="w-50 mb-0 text-primary table-heading">
            {"Reported Post List"}
          </h3>
          <div className="d-flex justify-content-end align-items-center gap-1">
            {/* Search section */}
            <CInputGroup className="" style={{ width: "300px" }} size="sm">
              <CInputGroupText className="cursor-pointer">
                <FaSearch />
              </CInputGroupText>
              <CFormInput
                value={inputValue}
                name="text"
                onChange={handleChange}
                placeholder="Search post name"
              />
              {inputValue && (
                <CInputGroupText
                  className="cursor-pointer"
                  onClick={handleClearInputField}
                >
                  <RxCross2 />
                </CInputGroupText>
              )}
            </CInputGroup>
          </div>
        </div>
        <CTable hover responsive>
          <CTableHead className="text-nowrap border">
            <CTableRow className="table-heading-text">
              <CTableHeaderCell className="bg-body-tertiary table-heading-10-cell">
                <CIcon icon={cilCamera} />
              </CTableHeaderCell>
              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-30-cell ${sortBy === "title" ? "sort-highlight" : ""}`}
              >
                {"Title"}
                <span onClick={() => handlerSort("title")}>
                  {sortOrder === 1 ? (
                    <BsSortAlphaDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortAlphaDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-20-cell ${sortBy === "reportCount" ? "sort-highlight" : ""}`}
              >
                {"Reported Count"}
                <span onClick={() => handlerSort("reportCount")}>
                  {sortOrder === 1 ? (
                    <BsSortNumericDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortNumericDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-20-cell ${sortBy === "createdAt" ? "sort-highlight" : ""}`}
              >
                {"Created At"}
                <span onClick={() => handlerSort("createdAt")}>
                  {sortOrder === 1 ? (
                    <BsSortNumericDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortNumericDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-20-cell ${sortBy === "reportedAt" ? "sort-highlight" : ""}`}
              >
                {"Reported At"}
                <span onClick={() => handlerSort("reportedAt")}>
                  {sortOrder === 1 ? (
                    <BsSortNumericDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortNumericDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          {isLoading ? <ProperSpinner /> : renderTableBody()}
        </CTable>
        {postsList?.length ? renderPagination() : null}
        {/* {!isLoading && postsList?.length == 0 && renderNoDataFound()} */}
        {(isLoading || postsList?.length == 0) && renderNoDataFound()}
      </div>
    );
  };
  return <div className="rm-table-container">{renderView()}</div>;
};

export default ReportedPostTable;
